import { ShiftSettingsService, type PostPutShiftSettingRequestAdmin } from '@/backend/market'
import { ShiftSettingRepository } from '../../domain/repositories/ShiftSettingRepository'
import { ShiftSettingModel } from '../models/ShiftSettingModel'
import type { ShiftSettingEntity } from '../../domain/entities/ShiftSettingEntity'
import type { PutShiftSettingEntity } from '../../domain/entities/PutShiftSettingEntity'
import { PutShiftSettingModel } from '../models/PutShiftSettingModel'

export class ShiftSettingRepositoryImpl implements ShiftSettingRepository {
  async getShiftSetting(): Promise<ShiftSettingEntity | { error: true }> {
    try {
      const response = await ShiftSettingsService.getShiftSettingAdmin()
      const shiftModel = new ShiftSettingModel(response)

      return shiftModel
    } catch {
      return { error: true }
    }
  }
  async putShiftSetting(
    shiftData: PutShiftSettingEntity
  ): Promise<ShiftSettingEntity | { error: true }> {
    const putShiftSettingModel = new PutShiftSettingModel(shiftData)
    try {
      const response = await ShiftSettingsService.postShiftSettingAdmin({
        requestBody: putShiftSettingModel as PostPutShiftSettingRequestAdmin
      })
      const shiftModel = new ShiftSettingModel(response)

      return shiftModel
    } catch {
      return { error: true }
    }
  }
}
